'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// import exuWhite from 'assets/img/account/exuWhite@2x.png';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _lib = require('../../helpers/lib');

var _support = require('helpers/support');

var _address2x = require('assets/img/account/address@2x.png');

var _address2x2 = _interopRequireDefault(_address2x);

var _defaultVoucherImage = require('assets/img/voucher/defaultVoucherImage.jpg');

var _defaultVoucherImage2 = _interopRequireDefault(_defaultVoucherImage);

var _expiredVoucherImage = require('assets/img/voucher/expiredVoucherImage.jpg');

var _expiredVoucherImage2 = _interopRequireDefault(_expiredVoucherImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlaceholderCard = function PlaceholderCard(styles) {
  return _react2.default.createElement(
    'div',
    { className: styles.product + ' ' + styles.noneProduct },
    _react2.default.createElement(
      'div',
      { className: styles.productImage },
      _react2.default.createElement(
        'div',
        { className: styles.imageContainer },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: styles.name },
          _react2.default.createElement('img', { src: '/error-img.svg' })
        )
      )
    )
  );
};

var VoucherCard = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(VoucherCard, _Component);

  function VoucherCard() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VoucherCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VoucherCard.__proto__ || (0, _getPrototypeOf2.default)(VoucherCard)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = _defaultVoucherImage2.default;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VoucherCard, [{
    key: 'render',
    value: function render() {
      var styles = require('./VoucherCard.scss');
      var data = this.props.data;

      if (!data) {
        return _react2.default.createElement(PlaceholderCard, { styles: styles });
      }
      var countDown = data.countDown,
          handle = data.handle,
          address = data.address,
          newPrice = data.newPrice,
          oldPrice = data.oldPrice,
          shopName = data.shopName,
          image = data.image,
          name = data.name,
          expired = data.expired;
      // limitDate, handle, address, newPrice, oldPrice, shopName

      return _react2.default.createElement(
        'div',
        { className: styles.product },
        _react2.default.createElement(
          'div',
          { className: styles.productImage },
          _react2.default.createElement(
            'div',
            { className: styles.imageContainer },
            _react2.default.createElement(
              'div',
              { className: styles.bannerImage },
              'C\xF2n ' + countDown + ' ng\xE0y'
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: styles.name, to: '/uu-dai/' + handle },
              expired ? _react2.default.createElement('img', { src: _expiredVoucherImage2.default }) : _react2.default.createElement('img', {
                src: (0, _lib.getUrlImage)(image),
                alt: name,
                onError: this.onErrorImage
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.productInfo },
          _react2.default.createElement(
            'div',
            { className: styles.voucherContainer },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: styles.name, to: '/uu-dai/' + handle },
              name
            ),
            _react2.default.createElement(
              'div',
              { className: styles.shopName, title: shopName ? shopName : null },
              _react2.default.createElement('img', { src: _address2x2.default, className: styles.mapIcon }),
              shopName ? shopName : null
            ),
            _react2.default.createElement(
              'div',
              { className: styles.address, title: address },
              address
            ),
            _react2.default.createElement('div', { className: styles.dashed })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.footerContainer },
            _react2.default.createElement(
              'div',
              { className: styles.price },
              _react2.default.createElement(
                'div',
                { className: styles.newPrice },
                expired ? '\u0110\xC3 H\u1EBET H\u1EA0N' : _support.Helper.formatMoney(newPrice)
              ),
              _react2.default.createElement(
                'div',
                { className: styles.oldPrice },
                expired ? null : _support.Helper.formatMoney(oldPrice)
              )
            )
          )
        )
      );
    }
  }]);
  return VoucherCard;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  notComment: _react.PropTypes.bool
}, _temp2);
exports.default = VoucherCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/VoucherCard.js
// module id = 261
// module chunks = 0